<template>
    <div class="c-loader">
        <div class="c-loader__spin">
            <i class="c-loader__icon fas fa-spinner-third fa-spin"></i>
            <span class="c-loader__label">Loading</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Loader"
    }
</script>
